import React, { useState, useEffect } from "react";
import { Card, Form, Button, Row, Col, Alert, Table, Badge } from "react-bootstrap";
import { db } from "../../firebase/firebase";
import { collection, doc, setDoc, getDocs, deleteDoc } from "firebase/firestore";
import { PersonPlus, Trash, People } from "react-bootstrap-icons";

const AdminUtilizatori = () => {
  const [utilizatori, setUtilizatori] = useState([]);
  const [formData, setFormData] = useState({
    email: "",
    nume: "",
    rol: "utilizator",
    ocol: "",
  });
  const [mesaj, setMesaj] = useState({ tip: "", text: "" });

  // 1. Încărcăm lista de utilizatori existenți
  const fetchUtilizatori = async () => {
    const querySnapshot = await getDocs(collection(db, "utilizatori"));
    const lista = querySnapshot.docs.map((doc) => ({
      id: doc.id,
      ...doc.data(),
    }));
    setUtilizatori(lista);
  };

  useEffect(() => {
    fetchUtilizatori();
  }, []);

  // 2. Salvare utilizator nou în Firestore
  const handleCreate = async (e) => {
    e.preventDefault();
    try {
      const emailLower = formData.email.toLowerCase().trim();

      await setDoc(doc(db, "utilizatori", emailLower), {
        nume: formData.nume,
        rol: formData.rol,
        ocol: formData.rol === "administrator" ? "Toate" : formData.ocol,
        email: emailLower,
      });

      setMesaj({
        tip: "success",
        text: `Profilul pentru ${emailLower} a fost creat cu succes!`,
      });
      setFormData({ email: "", nume: "", rol: "utilizator", ocol: "" });
      fetchUtilizatori();
    } catch (err) {
      setMesaj({ tip: "danger", text: "Eroare: " + err.message });
    }
  };

  // 3. Ștergere utilizator
  const handleDelete = async (id) => {
    if (window.confirm(`Ștergi profilul utilizatorului ${id}?`)) {
      await deleteDoc(doc(db, "utilizatori", id));
      fetchUtilizatori();
    }
  };

  return (
    <div className="p-4">
      <h3 className="mb-4">
        <People className="me-2" /> Administrare Personal
      </h3>

      <Row>
        {/* Formular Creare */}
        <Col lg={4}>
          <Card className="shadow-sm border-0 mb-4">
            <Card.Header className="bg-success text-white fw-bold">
              <PersonPlus className="me-2" /> Adaugă Utilizator Nou
            </Card.Header>
            <Card.Body>
              {mesaj.text && (
                <Alert
                  variant={mesaj.tip}
                  onClose={() => setMesaj({ text: "" })}
                  dismissible
                >
                  {mesaj.text}
                </Alert>
              )}
              <Form onSubmit={handleCreate}>
                <Form.Group className="mb-2">
                  <Form.Label className="small fw-bold">
                    Email (ID Logare)
                  </Form.Label>
                  <Form.Control
                    type="email"
                    value={formData.email}
                    required
                    onChange={(e) =>
                      setFormData({ ...formData, email: e.target.value })
                    }
                  />
                </Form.Group>
                <Form.Group className="mb-2">
                  <Form.Label className="small fw-bold">
                    Nume Complet
                  </Form.Label>
                  <Form.Control
                    type="text"
                    value={formData.nume}
                    required
                    onChange={(e) =>
                      setFormData({ ...formData, nume: e.target.value })
                    }
                  />
                </Form.Group>
                <Form.Group className="mb-2">
                  <Form.Label className="small fw-bold">Rol</Form.Label>
                  <Form.Select
                    value={formData.rol}
                    onChange={(e) =>
                      setFormData({ ...formData, rol: e.target.value })
                    }
                  >
                    <option value="utilizator">Utilizator (Ocol)</option>
                    <option value="administrator">Administrator</option>
                  </Form.Select>
                </Form.Group>
                <Form.Group className="mb-3">
                  <Form.Group className="mb-3">
                    <Form.Label className="small fw-bold">
                      Ocol atribuit
                    </Form.Label>
                    {formData.rol === "administrator" ? (
                      <Form.Control
                        type="text"
                        disabled
                        placeholder="Are acces la toate"
                        value="Toate"
                      />
                    ) : (
                      <Form.Select
                        required
                        value={formData.ocol}
                        onChange={(e) =>
                          setFormData({ ...formData, ocol: e.target.value })
                        }
                      >
                        <option value="">Alege Ocolul...</option>
                        <option value="Ludus">Ludus</option>
                        <option value="Targu Mures">Târgu Mureș</option>
                        <option value="Gurghiu">Gurghiu</option>
                        <option value="Fancel">Fancel</option>
                        <option value="Rastolita">Rastolita</option>
                        <option value="Lunca Bradului">Lunca Bradului</option>
                        <option value="Sovata">Sovata</option>
                        <option value="Tarnaveni">Tarnaveni</option>
                        <option value="Sighisoara">Sighisoara</option>
                      </Form.Select>
                    )}
                  </Form.Group>
                </Form.Group>
                <Button
                  variant="success"
                  type="submit"
                  className="w-100 fw-bold"
                >
                  Creează Profil
                </Button>
                <p className="mt-2" style={{ fontSize: "0.7rem" }}>
                  * Nu uita să adaugi acest email și în Firebase Authentication
                  cu o parolă.
                </p>
              </Form>
            </Card.Body>
          </Card>
        </Col>

        {/* Tabel Utilizatori */}
        <Col lg={8}>
          <Card className="shadow-sm border-0">
            <Card.Body>
              <Table responsive hover>
                <thead>
                  <tr>
                    <th>Utilizator</th>
                    <th>Rol</th>
                    <th>Ocol</th>
                    <th>Acțiuni</th>
                  </tr>
                </thead>
                <tbody>
                  {utilizatori.map((u) => (
                    <tr key={u.id}>
                      <td>
                        <div className="fw-bold">{u.nume}</div>
                        <div className="small">{u.email}</div>
                      </td>
                      <td>
                        <Badge
                          bg={u.rol === "administrator" ? "danger" : "primary"}
                        >
                          {u.rol}
                        </Badge>
                      </td>
                      <td>{u.ocol}</td>
                      <td>
                        <Button
                          variant="link"
                          className="text-danger"
                          onClick={() => handleDelete(u.id)}
                        >
                          <Trash />
                        </Button>
                      </td>
                    </tr>
                  ))}
                </tbody>
              </Table>
            </Card.Body>
          </Card>
        </Col>
      </Row>
    </div>
  );
};

export default AdminUtilizatori;
